slideshare_object.userActionsStore = {
  saveAction: function (action_type, action_data) {
    if (sessionStorage) {
      sessionStorage.setItem("ss_actiontype", action_type)
      sessionStorage.setItem("ss_actiondata", JSON.stringify(action_data))
    } else {
      window.cookie("ss_actiontype", action_type)
      window.cookie("ss_actiondata", JSON.stringify(action_data))
    }
  },

  getStoredAction: function () {
    let ss_actiontype = null
    let ss_actiondata = null

    if (sessionStorage) {
      ss_actiontype = sessionStorage.getItem("ss_actiontype")
      ss_actiondata = sessionStorage.getItem("ss_actiondata")

      if (ss_actiontype !== null && ss_actiondata !== null) {
        sessionStorage.removeItem("ss_actiontype")
        sessionStorage.removeItem("ss_actiondata")
      }
    } else {
      ss_actiontype = window.cookie("ss_actiontype")
      ss_actiondata = window.cookie("ss_actiondata")

      if (ss_actiontype !== null && ss_actiondata !== null) {
        window.cookie = "ss_actiontype=; expires=Thu, 01 Jan 1970 00:00:01 GMT;"
        window.cookie = "ss_actiondata=; expires=Thu, 01 Jan 1970 00:00:01 GMT;"
      }
    }

    if (ss_actiontype !== null && ss_actiondata !== null) {
      return {
        action_type: ss_actiontype,
        action_data: JSON.parse(ss_actiondata),
      }
    } else {
      return null
    }
  },

  saveLike: function (slideshow_id, load_modal) {
    let action_type = "ss_like"

    let data = {
      ss_id: slideshow_id,
      load_modal: typeof load_modal !== "undefined" ? load_modal : false,
    }
    this.saveAction(action_type, data)
  },

  saveFollow: function (contactee_login, load_modal, slideshow_id) {
    let action_type = "ss_follow"
    let data = {
      contactee: contactee_login,
      load_modal: typeof load_modal !== "undefined" ? load_modal : false,
      slideshow_id: typeof load_modal !== "undefined" ? slideshow_id : null,
    }
    this.saveAction(action_type, data)
  },

  saveBulkFollow: function (contactees) {
    let action_type = "ss_follow"
    let data = {
      contactee: contactees,
      load_modal: false,
      slideshow_id: null,
    }
    this.saveAction(action_type, data)
  },

  saveComment: function (comment_text, slideshow_id, load_modal) {
    let action_type = "ss_comment"
    let data = {
      ss_id: slideshow_id,
      comment: comment_text,
      load_modal: typeof load_modal !== "undefined" ? load_modal : false,
    }
    this.saveAction(action_type, data)
  },
}
